const SITE_NAME = "SHAH PREMIUM FOODS";
const SITE_URL = "https://shahpremiumfoods.com";
const DEFAULT_IMAGE = SITE_URL + "/static/fav.png";

function setMeta(attr, key, content) {
  let el = document.head.querySelector("meta[" + attr + '="' + key + '"]');
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(url) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", url);
}

function trim(text, max) {
  const clean = String(text || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  return clean.length > max ? clean.slice(0, max - 1).trim() + "…" : clean;
}

// opts: { title, description, image, path, noindex }
export function setSeo(opts) {
  const title = trim(opts.title, 60);
  const fullTitle = title ? title + " | " + SITE_NAME : SITE_NAME;
  const description = trim(opts.description, 160);
  const path = opts.path || window.location.pathname;
  const url = SITE_URL + path;
  const image = opts.image || DEFAULT_IMAGE;

  document.title = fullTitle;
  setMeta("name", "description", description);
  setMeta(
    "name",
    "robots",
    opts.noindex ? "noindex, nofollow" : "index, follow"
  );
  setCanonical(url);

  setMeta("property", "og:site_name", SITE_NAME);
  setMeta("property", "og:type", "website");
  setMeta("property", "og:title", fullTitle);
  setMeta("property", "og:description", description);
  setMeta("property", "og:url", url);
  setMeta("property", "og:image", image);
  setMeta("name", "twitter:card", "summary_large_image");
  setMeta("name", "twitter:title", fullTitle);
  setMeta("name", "twitter:description", description);
  setMeta("name", "twitter:image", image);
}

export function seoFromRoute(route, routeSeo) {
  const seo = routeSeo || {};
  let title = seo.title;
  let description = seo.description;
  if (typeof title === "function") title = title(route);
  if (typeof description === "function") description = description(route);
  setSeo({
    title: title || "Online Supermarket & Grocery Delivery",
    description:
      description ||
      "Shop fresh vegetables, fish, chicken, organic food and groceries online at SHAH PREMIUM FOODS.",
    path: route.path,
    noindex: seo.noindex
  });
}

export function humanize(slug) {
  return decodeURIComponent(String(slug || ""))
    .replace(/[-_]+/g, " ")
    .replace(/\b\w/g, c => c.toUpperCase());
}
